import {
	Component,
	OnInit,
	ViewEncapsulation,
	AfterViewInit,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import * as Papi from "@app/papi";
declare let mLayout: any;
@Component({
	selector: "app-aside-nav",
	templateUrl: "./aside-nav.component.html",
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class AsideNavComponent implements OnInit, AfterViewInit {
	isOpen = false;
	isChildRouteActive = false;
	isAuditLogsOpen = false;
	isAuditLogsRouteActive = false;

	constructor(public papi: Papi.Service, private router: Router) {
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.checkActiveRoutes();
			}
		});
	}

	ngOnInit() {
		this.checkActiveRoutes();
		this.papi.authorize("arcadmin").subscribe((result: boolean) => {
			// force initialization of actions cache
		});
	}

	checkActiveRoutes(): void {
		const currentUrl = this.router.url || '';
		this.isChildRouteActive = currentUrl.startsWith('/meridian-location') || currentUrl.startsWith('/meridian-map');
		this.isAuditLogsRouteActive = currentUrl.startsWith('/audit-logs');
		if (this.isAuditLogsRouteActive) {
			this.isAuditLogsOpen = true;
		}
		if (this.isChildRouteActive) {
			this.isOpen = true;
		}
	}

	toggleMenu(event: Event): void {
		event.stopPropagation();
		this.isOpen = !this.isOpen;
	}

	toggleAuditLogs(event?: Event): void {
		if (event) {
			event.stopPropagation();
		}
		this.isAuditLogsOpen = !this.isAuditLogsOpen;
	}

	ngAfterViewInit() {
		mLayout.initAside();
	}
}
